import { render, staticRenderFns } from "./TabContractSubContracts.vue?vue&type=template&id=742c1afd&scoped=true"
import script from "./TabContractSubContracts.vue?vue&type=script&lang=js"
export * from "./TabContractSubContracts.vue?vue&type=script&lang=js"
import style0 from "./TabContractSubContracts.vue?vue&type=style&index=0&id=742c1afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c1afd",
  null
  
)

export default component.exports